/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actiontypes from './actiontypes';
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import { singleAccRecNDCDetail } from '../../AccRecNDCDetail/store/actions';
import { dispatchClearARSummaryByQtrData } from '../../ARSummaryByQtr/store/actions';

export const singleAccRecNDCData = (data) => ({
  type: actiontypes.SINGLE_ACC_REC_NDC_TABLE,
  getSingleAccRecNDCList: data,
});

export const qtrAccRecFieldValues = (data) => ({
  type: actiontypes.SINGLE_ACC_REC_FIELD_VALUES,
  getAccRecFieldvalues: data,
});

export const dispatchQARBalanceDue = (val) => ({
  type: actiontypes.QAR_BALANCE_DUE,
  getBalnceDue: val,
});
export const dispatchQAROveridden = (val) => ({
  type: actiontypes.QAR_OVERRIDDEN,
  getOverridden: val,
});
export const dispatchQARPaidInFull = (val) => ({
  type: actiontypes.QAR_PAID_FULL,
  getPaidInFull: val,
});
export const getAccRecNDCSingleDetail = (val) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${serviceEndPoint.GET_AR_NDC_SGL_RPC}`, val)
      .then((response) => {
        let accRecNDCDetailData = {
          [val.rebateProgramCd]: response.data,
        };
        dispatch(singleAccRecNDCData(response.data));
        dispatch(singleAccRecNDCDetail(accRecNDCDetailData));
        resolve(response.data); // Resolve the promise with the response data
      })
      .catch((error) => {
        dispatch(singleAccRecNDCData([]));
        dispatch(singleAccRecNDCDetail([]));
        reject(error); // Reject the promise with the error
      });
  });
};

export const dispatchClearARQtrAccountRecReduxData = (val) => {
  return {
    type: actiontypes.AR_QTR_ACCOUNT_REC_FIELD_CLEAR_REDUX,
    payload: val,
  };
};

export const clearQtrAccountRecPage = (history) => (dispatch, getState) => {
  const reduxObj1 = getState()?.sharedState?.QtrAccountsRecReducer;
  const reduxObj = getState()?.sharedState?.ArSummaryQtrReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let changePass = false;
  let newObj1 = {};
  let nObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    const nObj = _.cloneDeep(reduxObj1);
    if (updateTabs.filter((x) => x.navTo === '/ARSummaryByQtr').length === 0) {
      nObj1 = {};
      newObj1 = {};
      changePass = true;
    } else {
      newObj.ar_smry_single_qtr = reduxObj.ar_smry_single_qtr || {};
      newObj.getQuarterValue = reduxObj.getQuarterValue || null;
      newObj1 = newObj;
    }
  } else {
    changePass = true;
    nObj1 = {};
    newObj1 = {};
  }
  if (changePass) {
    dispatch(dispatchClearARSummaryByQtrData(newObj1));
  }
  dispatch(dispatchClearARQtrAccountRecReduxData(nObj1));
};
